import React from 'react';
import GemLogo from '../image/GemLogo.svg';

export default function GeMSection() {
  return (
    <section className="section-padding premium-cert-section text-center position-relative overflow-hidden">
      <div className="container position-relative z-1">
        {/* Section Pill */}
        <span className="section-pill mb-3">We Are GeM Registered</span>

        {/* Section Heading */}
        <h2 className="section-heading text-dark mb-3 fs-3 fs-md-2">
          Government e-Marketplace (GeM) <span className="text-primary fst-italic">Registered Vendor</span>
        </h2>

        {/* Description */}
        <p
          className="text-muted-dark mx-auto mb-4 mb-md-5 px-2 px-md-0"
          style={{ maxWidth: '780px', fontSize: '1.05rem', lineHeight: '1.7' }}
        >
          Our company is registered on the <strong className="text-dark">GeM Portal (gem.gov.in)</strong>,
          enabling us to participate in government procurement in accordance with Government of India guidelines.
        </p>

        {/* GeM Logo Display Box */}
        <div className="d-flex justify-content-center mt-3">
          <div
            className="white-card p-3 p-md-3 rounded-4 shadow-sm border transition-all hover-lift"
            style={{ maxWidth: '420px', width: '90%', background: '#000000ff' }}
          >
            <img
              src={GemLogo}
              alt="Government e-Marketplace GeM Registered Vendor"
              className="img-fluid rounded-3"
              style={{ display: 'block', width: '100%', height: 'auto' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
